module.exports = __webpack_public_path__ + "img/service_bg.3fe90b7.png";